module.exports = __webpack_public_path__ + "img/LATIN10_30.f321bc85.jpg";